import { Link, Outlet, useLocation } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import Logo from './Logo';
import { useEffect } from 'react';
import SupportChatbot from './SupportChatbot';

const menuItems = [
  { path: '/crm', label: 'Dashboard', icon: 'ri-dashboard-line' },
  { path: '/crm/leads', label: 'Leads', icon: 'ri-contacts-line' },
  { path: '/crm/search', label: 'B2B-Suche', icon: 'ri-search-line' },
];

export default function CrmLayout() {
  const { user, userRole, signOut } = useAuth();
  const location = useLocation();

  const navItems = [
    { path: '/crm', label: 'Dashboard', icon: 'ri-dashboard-line' },
    { path: '/crm/leads', label: 'CRM', icon: 'ri-user-line' },
    { path: '/crm/search', label: 'Lead-Suche', icon: 'ri-search-line' },
    { path: '/crm/templates', label: 'Templates', icon: 'ri-mail-line' }
  ];

  const isActive = (path: string) => {
    return location.pathname === path || location.pathname.startsWith(path + '/');
  };

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Header */}
      <header className="bg-white border-b border-gray-200">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex items-center justify-between h-16">
            <div className="flex items-center space-x-8">
              <Link to="/">
                <Logo />
              </Link>
              <nav className="flex space-x-1">
                <Link
                  to="/crm"
                  className={`px-4 py-2 rounded-lg text-sm font-medium transition-colors whitespace-nowrap ${
                    location.pathname === '/crm'
                      ? 'bg-teal-50 text-teal-700'
                      : 'text-slate-600 hover:text-slate-900 hover:bg-slate-50'
                  }`}
                >
                  <i className="ri-home-line mr-2"></i>
                  Start
                </Link>
                <Link
                  to="/crm/leads"
                  className={`px-4 py-2 rounded-lg text-sm font-medium transition-colors whitespace-nowrap ${
                    isActive('/crm/leads') || isActive('/lead')
                      ? 'bg-teal-50 text-teal-700'
                      : 'text-slate-600 hover:text-slate-900 hover:bg-slate-50'
                  }`}
                >
                  <i className="ri-user-line mr-2"></i>
                  CRM
                </Link>
                <Link
                  to="/crm/search"
                  className={`px-4 py-2 rounded-lg text-sm font-medium transition-colors whitespace-nowrap ${
                    isActive('/crm/search')
                      ? 'bg-teal-50 text-teal-700'
                      : 'text-slate-600 hover:text-slate-900 hover:bg-slate-50'
                  }`}
                >
                  <i className="ri-building-line mr-2"></i>
                  B2B-Suche
                </Link>
                <Link
                  to="/crm/marketing"
                  className={`px-4 py-2 rounded-lg text-sm font-medium transition-colors whitespace-nowrap ${
                    isActive('/crm/marketing')
                      ? 'bg-purple-50 text-purple-700'
                      : 'text-slate-600 hover:text-slate-900 hover:bg-slate-50'
                  }`}
                >
                  <i className="ri-magic-line mr-2"></i>
                  Marketing
                </Link>
                <Link
                  to="/crm/links"
                  className={`px-4 py-2 rounded-lg text-sm font-medium transition-colors whitespace-nowrap ${
                    isActive('/crm/links')
                      ? 'bg-teal-50 text-teal-700'
                      : 'text-slate-600 hover:text-slate-900 hover:bg-slate-50'
                  }`}
                >
                  <i className="ri-links-line mr-2"></i>
                  Meine Links
                </Link>
                <Link
                  to="/crm/hilfe"
                  className={`px-4 py-2 rounded-lg text-sm font-medium transition-colors whitespace-nowrap ${
                    isActive('/crm/hilfe')
                      ? 'bg-teal-50 text-teal-700'
                      : 'text-slate-600 hover:text-slate-900 hover:bg-slate-50'
                  }`}
                >
                  <i className="ri-question-line mr-2"></i>
                  Hilfe
                </Link>
                <Link
                  to="/crm/schulung"
                  className={`px-4 py-2 rounded-lg text-sm font-medium transition-colors whitespace-nowrap ${
                    isActive('/crm/schulung')
                      ? 'bg-teal-50 text-teal-700'
                      : 'text-slate-600 hover:text-slate-900 hover:bg-slate-50'
                  }`}
                >
                  <i className="ri-graduation-cap-line mr-2"></i>
                  Schulung
                </Link>
                <Link
                  to="/crm/settings"
                  className={`px-4 py-2 rounded-lg text-sm font-medium transition-colors whitespace-nowrap ${
                    isActive('/crm/settings')
                      ? 'bg-teal-50 text-teal-700'
                      : 'text-slate-600 hover:text-slate-900 hover:bg-slate-50'
                  }`}
                >
                  <i className="ri-settings-3-line mr-2"></i>
                  Einstellungen
                </Link>
                {userRole === 'admin' && (
                  <Link
                    to="/admin"
                    className={`px-4 py-2 rounded-lg text-sm font-medium transition-colors whitespace-nowrap ${
                      isActive('/admin')
                        ? 'bg-orange-50 text-orange-700'
                        : 'text-slate-600 hover:text-slate-900 hover:bg-slate-50'
                    }`}
                  >
                    <i className="ri-shield-star-line mr-2"></i>
                    Admin
                  </Link>
                )}
              </nav>
            </div>
            <div className="flex items-center space-x-4">
              <span className="text-sm text-gray-600">{user?.email}</span>
              <button
                onClick={() => signOut()}
                className="text-sm text-gray-600 hover:text-gray-900 whitespace-nowrap"
              >
                Abmelden
              </button>
            </div>
          </div>
        </div>
      </header>

      {/* Content */}
      <Outlet />

      {/* Support-Chatbot */}
      <SupportChatbot />
    </div>
  );
}
